/**
 * @fileoverview Default display fallbacks for raw property field extraction (QMA + details UI).
 * @module constants/propertyFieldDefaults
 */

export const DEFAULT_UNKNOWN = "Unknown";
export const DEFAULT_NOT_AVAILABLE = "N/A";
export const DEFAULT_EMPTY_STRING = "";
